module.exports = __webpack_public_path__ + "static/media/yandex-icon.3c225d68.svg";